export default __webpack_public_path__ + "app/components/notifications/notifications.html";